import $ from 'jquery';
import BezierEasing from 'bezier-easing';
import Change from './Change';

const defaults = {
  distance: 90, // How far to travel in px
};

export default class Parallax {
  constructor(element, options) {
    this.element = element;
    this.$element = $(element);
    this.settings = Object.assign(defaults, options);
    this.easing = BezierEasing(0.23, 1, 0.32, 1); // easeOutQuint
    this.animating = false;
    this.bounds = {};
    this.register();
    this.update();
  }

  register() { Change.onChange(this.update.bind(this)); }

  elementIsOnScreen() {
    return window.innerHeight - this.bounds.top >= 0;
  }

  update() {
    const wh = window.innerHeight;
    this.bounds = this.element.getBoundingClientRect();
    if (this.elementIsOnScreen() && !this.animating) {
      this.animating = true;
      // Factor percentage of the block being visible within the viewport.
      let pct = (wh - this.bounds.top) / (this.bounds.height + 100);

      // Create a factor based on the current Y coupled with the ease at that percentage.
      let factor = this.easing(pct);

      // -------------------------------------------------------------------
      // Move the block title
      // -------------------------------------------------------------------
      if (pct >= 1) { pct = 1; }
      if (factor >= 1) { factor = 1; }

      const tPos = this.settings.distance * (pct);

      // Create position based on current Y pos of block coupled with the easing factor.
      const tPct = tPos * factor;

      // Move the block title based on the currently factored value.
      this.$element.find('.block-title').css('top', `${tPct}px`);

      // Notify that the animation is complete.
      this.animating = false;
    }
  }
}
